export function PageHeader({ eyebrow, title, actions, children }) {
  return (
    <div className="mb-8 flex items-end justify-between gap-4 flex-wrap">
      <div>
        {eyebrow && <div className="label-caps mb-2">{eyebrow}</div>}
        <h1 className="text-3xl font-bold" style={{ fontFamily: "Chivo" }}>{title}</h1>
        {children && <div className="mt-2 text-sm" style={{ color: "var(--text-dim)" }}>{children}</div>}
      </div>
      {actions && <div className="flex gap-2 flex-wrap">{actions}</div>}
    </div>
  );
}

export function EmptyState({ title, description, action }) {
  return (
    <div className="card p-10 text-center" style={{ background: "var(--surface)" }}>
      <div className="label-caps mb-2">Vazio</div>
      <div className="text-lg font-semibold mb-1" style={{ fontFamily: "Chivo" }}>{title}</div>
      {description && <div className="text-sm mb-4" style={{ color: "var(--text-dim)" }}>{description}</div>}
      {action}
    </div>
  );
}

export function Modal({ open, onClose, title, children, footer, testid }) {
  if (!open) return null;
  return (
    <div className="modal-backdrop" onClick={onClose}>
      <div className="modal" data-testid={testid} onClick={(e) => e.stopPropagation()}>
        <div className="px-5 py-4 border-b flex items-center justify-between" style={{ borderColor: "var(--border)" }}>
          <h3 className="text-lg font-semibold" style={{ fontFamily: "Chivo" }}>{title}</h3>
          <button className="btn btn-ghost" onClick={onClose} data-testid="modal-close">✕</button>
        </div>
        <div className="p-5">{children}</div>
        {footer && <div className="px-5 py-4 border-t flex justify-end gap-2" style={{ borderColor: "var(--border)" }}>{footer}</div>}
      </div>
    </div>
  );
}

export function StatusBadge({ status }) {
  const map = {
    aberta: { cls: "badge-open", label: "Aberta" },
    em_andamento: { cls: "badge-progress", label: "Em Andamento" },
    concluida: { cls: "badge-done", label: "Concluída" },
    cancelada: { cls: "badge-cancel", label: "Cancelada" },
    ativo: { cls: "badge-done", label: "Ativo" },
    manutencao: { cls: "badge-progress", label: "Manutenção" },
    inativo: { cls: "badge-cancel", label: "Inativo" },
    encerrado: { cls: "badge-cancel", label: "Encerrado" },
  };
  const c = map[status] || { cls: "badge-open", label: status };
  return <span className={`badge ${c.cls}`}>{c.label}</span>;
}
